import { jsx as emotion } from "@emotion/react";
import css, { SystemStyleObject } from "@styled-system/css";
import lodashOmit from "lodash/omit";

const parseProps = (props: any) => {
  if (!props) {
    return null;
  }
  if (!props.sx) {
    return props;
  }

  return lodashOmit(
    {
      ...props,
      css: css(props.sx as SystemStyleObject),
    },
    "sx"
  );
};

/**
 * FIXME: These props are used in the app, but are not part of
 * SystemStyleObject types in the latest version. Instead of fixing
 * them in every location, they're being
 * added to general jsx props. But, they should be cleaned up eventually.
 */
export interface FaultySxProps {
  gridGap?: any;
  gridRowGap?: any;
  gridColumnGap?: any;
  WebkitLineClamp?: any;
  WebkitBoxOrient?: any;
  size?: any;
}

/**
 * @deprecated Please use `styled()` from \@outschool/backpack for adding the sx prop.
 */
export default function jsxPragma(type: any, props: any, ...children: any[]) {
  return emotion(type, parseProps(props), ...children);
}
